"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndeterminateSwitch = IndeterminateSwitch;
exports.Switch = Switch;
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _Checkbox = require("./Checkbox");
var _excluded = ["className", "intent"],
  _excluded2 = ["className", "intent"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Switch(_ref) {
  var className = _ref.className,
    intent = _ref.intent,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _classnames.default)(_classes.Classes.intentClass(intent), className);
  return /*#__PURE__*/React.createElement(_core.Switch, _extends({
    className: classes
  }, props));
}
/**
 * Natively the Switch does not support an indeterminate state
 *
 * I decided to make this state a separate component, in order to not mess with the existing
 * implementation functionality of the Switch component
 *
 * For the indeterminate state we fudge it and display a Checkbox but add a switch class
 * We can do this because
 * - The underlying switch docs say its essentially a checkbox with different styling
 * - The checkbox already has the interface for an indeterminate state, which makes things easier
 */

function IndeterminateSwitch(_ref2) {
  var className = _ref2.className,
    intent = _ref2.intent,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var classes = (0, _classnames.default)(_classes.Classes.intentClass(intent), _classes.Classes.SWITCH, className);
  return /*#__PURE__*/React.createElement(_Checkbox.Checkbox, _extends({
    className: classes
  }, props));
}